import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import ProductFeedForm from '../../components/ProductFeeds/ProductFeedForm';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['productFeed']}`;

const ProductFeedsDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();

  const [productFeed, setProductFeed] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [loading, setLoading] = useState(false);
  const { accountId, domainId, productFeedId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeedId}`)
      .then(({ productFeed }) => setProductFeed(productFeed))
      .catch(setLoadError);
  }, [accountId, domainId, fetch, productFeedId]);

  const update = (productFeed) => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeedId}`, {
      method: 'PUT',
      body: JSON.stringify(productFeed),
    })
      .then(() => {
        navigate(`/accounts/${accountId}/domains/${domainId}/productFeeds`);
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeed.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(`/accounts/${accountId}/domains/${domainId}/productFeeds`);
      })
      .catch(setLoadError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (productFeed === undefined) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/productFeeds` },
    {
      title: productFeed?.name || 'Unknown Product Feed',
      href: `#/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeed?.id}/analytics`,
    },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${productFeed?.name || 'Unknown productFeed'} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <ProductFeedForm
            loading={loading}
            productFeed={productFeed}
            saveProductFeed={(productFeed) => update(productFeed)}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/productFeeds`)}
            deleteProductFeed={(cb) => del(cb)}
          />
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default ProductFeedsDetailsPage;
